// eslint-disable-next-line import/no-unresolved
import React from "react";
import classNames from "classnames";

import "./button.scss";

const Button = ({ attributes, modifier, events, children }) => {
  const { disabled, secondary, tertiary, className } = modifier;
  const { id, type } = attributes;
  const { onClick } = events;

  return (
    <button
      className={`btn ${classNames(className, {
        secondary,
        tertiary,
        disabled,
      })}`}
      disabled={disabled}
      id={id}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  attributes: {
    id: "button",
    type: "button"
  },
  modifier: {
    disabled: false,
    secondary: false,
    tertiary: false,
    className: "",
  },
  events: {
    onClick: undefined
  },
};

export default Button;
